/**
 * Utilitaires pour la gestion des images
 */

/**
 * Vérifie si une URL d'image est valide et accessible
 * @param {string} url - URL de l'image à vérifier
 * @returns {Promise<boolean>} - True si l'image est valide
 */
export async function isValidImageUrl(url) {
  if (!url) return false
  
  // Vérifier si c'est une URL d'exemple ou invalide
  if (url.includes('example.com') || url.includes('placeholder') || url === '') {
    return false
  }
  
  // Vérifier si c'est une URL locale valide
  if (url.startsWith('/src/assets/')) {
    return true
  }
  
  // Pour les URLs externes, on peut faire une vérification plus poussée
  // mais pour l'instant on considère qu'elles sont valides
  return true
}

/**
 * Vérifie si une image est chargée avec succès
 * @param {string} url - URL de l'image
 * @returns {Promise<boolean>} - True si l'image se charge correctement
 */
export function checkImageLoad(url) {
  return new Promise((resolve) => {
    if (!url) {
      resolve(false)
      return
    }
    
    const img = new Image()
    img.onload = () => resolve(true)
    img.onerror = () => resolve(false)
    img.src = url
  })
}

/**
 * Vérifie si une URL d'image est valide pour l'affichage
 * @param {string} url - URL de l'image
 * @returns {boolean} - True si l'image peut être affichée
 */
export function canDisplayImage(url) {
  if (!url) return false
  
  // URLs d'exemple ou invalides
  if (url.includes('example.com') || url.includes('placeholder') || url === '') {
    return false
  }
  
  // URLs locales valides (commencent par /src/assets/)
  if (url.startsWith('/src/assets/')) {
    return true
  }
  
  // URLs externes valides (commencent par http/https)
  if (url.startsWith('http://') || url.startsWith('https://')) {
    return true
  }
  
  // Toutes les autres URLs sont considérées comme invalides
  return false
}
